import React from "react";
// Components
import MenuReports from "../../components/MenuReports";

function ReportsPage() {
  return <MenuReports />;
}

export default ReportsPage;
